import { FC, useState } from 'react'
import { MaintainerModal } from '@/presentation/common/components/maintainer/MaintainerModal.tsx'
import { SidebarButton } from '@/presentation/common/components/SidebarButton.tsx'
import { useCrudAuth } from '@/presentation/common/hooks/crud/useCrudAuth.ts'
import { useActionsModal } from '@/presentation/common/hooks/useActionsModal.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { CreateProductsTemplateForm } from '@/presentation/productsTemplates/forms/CreateProductsTemplateForm.tsx'
import { DeleteProductsTemplatesForm } from '@/presentation/productsTemplates/forms/DeleteProductsTemplatesForm.tsx'
import { ProductsTemplatesActionsProps } from '@/presentation/productsTemplates/forms/types.ts'
import { UpdateProductsTemplateForm } from '@/presentation/productsTemplates/forms/UpdateProductsTemplateForm.tsx'

export const ProductsTemplatesActions: FC<ProductsTemplatesActionsProps> = ({ onAction }) => {
  const selectionCount = useMaintainerStore((state) => state.selectionCountV2())
  const { canCreate, canUpdate, canDelete } = useCrudAuth()
  const { open, setOpen } = useActionsModal()
  const [ option, setOption ] = useState<'POST' | 'PUT' | 'DELETE' | null>(null)

  const isPost = option === 'POST'
  const isPut = option === 'PUT'
  const isDelete = option === 'DELETE'

  const title = isPost ? 'Registrar plantilla para mantención' : isPut ? 'Actualizar plantilla para mantención' : 'Eliminar selección'

  const closeModal = () => {
    setOpen(false)
    setOption(null)
  }

  const onFinish = () => {
    closeModal()
    onAction?.call(this)
  }

  return (
    <>
      <MaintainerModal title={title} open={open}>
        {isPost && <CreateProductsTemplateForm onCancel={closeModal} onFinish={onFinish}/>}
        {isPut && <UpdateProductsTemplateForm onCancel={closeModal} onFinish={onFinish}/>}
        {isDelete && <DeleteProductsTemplatesForm onCancel={closeModal} onFinish={onFinish}/>}
      </MaintainerModal>

      {canCreate && (
        <SidebarButton label="Registrar plantilla" type="POST" onClick={() => {
          setOption('POST')
          setOpen(true)
        }}/>
      )}

      {canUpdate && (
        <SidebarButton label="Actualizar plantilla" type="PUT" onClick={() => {
          setOption('PUT')
          setOpen(true)
        }}/>
      )}

      {canDelete && (
        <SidebarButton label={`Eliminar selección (${selectionCount})`} type="DELETE" onClick={() => {
          setOption('DELETE')
          setOpen(true)
        }}/>
      )}
    </>
  )
}
